// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"e8170bcf","207":"85d84d1d","531":"8f45f92b","972":"20270f7e"}[chunkId] + ".chunk.js";
};